<template>
  <div class="customer-list-installments">
    <h2>Histórico de pagamentos <span style="font-size: 12px; margin-left: 5px; background-color: #1c56e0; color: #FFF; padding: 3px 10px; border-radius: 10px; font-weight: 400;" v-if="installmentsType == 'extend'">Prorrogado</span>
      <div v-if="loading" class="spinner-border spinner-border-sm installments-loading" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </h2>
    <div class="item">
      <table>
        <tr v-for="i in data" v-bind:key="i.id">
          <td style="min-width: 80px; width: 80px">
            <a :href="i.boletosPage" target="_blank">
              <template v-if="i.pixSettled"><strong>Entrada</strong></template>
              <template v-else><strong>Parcela {{ i.installment }}</strong></template>
            </a>
          </td>
          <td class="text-truncate">{{ i.dueDate | moment-month }}</td>
          <td class="text-truncate"><strong>{{ i.amount | numeral('$ 0,0.00') }}</strong></td>
          <td style="min-width: 100px; width: 100px"><span :class="i.pixSettled ? 'success' : (i.status === 'Paga') ? 'success' : ((i.status === 'Pendente' || i.status === 'Cancelado') ? 'danger' : 'warning')">{{ i.pixSettled ? 'Pago Pix' : i.status }}</span></td>
          <td v-if="$auth.check('ROLE_SUPER')" class="item-pix-button">
            <div class="item-pix-btn-container" v-if="$auth.check('ROLE_SUPER') && i.status === 'Pendente' && !i.dueDateBefore">
              <button class="button-toggle-pix" @click.prevent="togglePixDropdown(i.installment)"><i class="icon-more-squares-vertical-filled"></i></button>
              <div class="menu-pix-options">
                <ul :id="`ul-${i.installment}`" v-show="false">
                  <li v-if="i.pixCodigoQrCode">
                    <button @click="copyToClipboard(i.pixCodigoQrCode)">Copiar código PIX</button>
                  </li>
                  <li>
                    <button v-if="!loadingPix" @click="regenPix(i)">Gerar PIX</button>
                    <button v-else>Carregando...</button>
                  </li>
                </ul>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  data () {
    return {
      data: [],
      uuid: this.$route.params.txid,
      loading: false,
      nextInstallment: null,
      totalInstallments: null,
      statePixMenu: false,
      loadingPix: false,
      installmentsType: ''
    }
  },
  mounted () {
    this.getCustomerInstallments()
  },
  methods: {
    getCustomerInstallments () {
      this.loading = true
      this.$http.get('api/order-validation/' + this.$route.params.txid + '/customer-installments')
        .then(function (res) {
          res.data.listInstallments.map(obj => {
            this.data.push({
              installment: obj.installment,
              dueDate: obj.dueDate,
              amount: obj.amount,
              status: obj.status,
              pixCodigoQrCode: obj.pixCodigoQrCode,
              paymentType: obj.paymentType,
              dueDateBefore: moment(obj.dueDate).isBefore(moment()),
              boletosPage: `https://meu.boletoflex.com/#/${this.$route.params.txid}`,
              pixSettled: obj.pixSettled
            })
            if (obj.status === 'Pendente' || obj.status === 'Paga') {
              this.totalInstallments += 1
            }
          })

          for (let i = 0; i < res.data.listInstallments.length; i++) {
            const nextInstallment = res.data.listInstallments[i]
            if (nextInstallment.status === 'Pendente') {
              this.nextInstallment = nextInstallment
              break
            }
          }

          this.$emit('emit-next-installment', this.nextInstallment)
          this.$emit('emit-total-installments', this.totalInstallments)
          this.loading = false

          this.installmentsType = res.data.installmentsType
        })
        .catch(function (res) {
          console.error('Error')
          console.error(res)
          this.loading = false
        })
    },
    regenPix (i) {
      this.loadingPix = true
      let dueDate = moment(i.dueDate).format('YYYY-MM-DD')

      this.$http.put('pix/avulso/' + this.$route.params.txid + '/' + i.installment + '/BOL/0/' + dueDate + '/' + i.amount)
        .then(() => {
          this.$bvToast.toast('Código PIX gerado com sucesso', {
            autoHideDelay: 5000,
            variant: 'success'
          })
          this.loadingPix = false
          this.data = []
          this.getCustomerInstallments()
        })
      console.log(i)
    },
    togglePixDropdown (id) {
      let show = document.getElementById(`ul-${id}`).style.display === 'none' ? 'block' : 'none'
      document.getElementById(`ul-${id}`).style.display = show
    },
    copyToClipboard (str) {
      // try {
      console.log(str)
      const el = document.createElement('textarea')
      el.value = str
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      this.$bvToast.toast('Código PIX copiado com sucesso', {
        autoHideDelay: 5000,
        variant: 'success'
      })
      // } catch {
      //   this.$bvToast.toast('Erro ao copiar código PIX', {
      //     autoHideDelay: 5000,
      //     variant: 'danger'
      //   })
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.customer-list-installments {
  margin: 16px;
  .installments-loading {
    margin-left: 5px;
    color: #4285F4;
    font-size: 5px;
  }
  table {
    margin: 0;
    padding: 0;
    display: flow-root;
    overflow: hidden;
    tr {
      list-style: none;
      margin: 0;
      padding: 8px 0;
      display: flex;
      justify-content: space-between;
      border-bottom: solid 1px #e5e5e5;
      align-items: center;

      .item-pix-button {
        display: flex;
        align-items: center;
        justify-content: center;
        position: static;
        width: 40px;

        .item-pix-btn-container{
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          .button-toggle-pix {
            width: 26px;
            height: 26px;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #1c56e0;
            font-size: 12px;
            color: #ffffff;
            line-height: 12px;
          }

          .menu-pix-options {
            position: absolute;
            right: 70px;
            z-index: 10;
            border: 1px solid #F9F9F9;
            border-radius: 4px;
            box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
            background-color: #FFFFFF;
            ul {
              padding: 8px 0;
              margin: 0;
              li {
                padding: 8px 16px;
                list-style: none;
                border-bottom: 1px solid #F9F9F9;
                &:last-child {
                  border: none;
                }
                button {
                  display: contents;
                  color: #000000;
                  text-align: left;
                  padding: 0;
                  margin: 0;
                  border: none;
                  background-color: transparent;
                  &.primary {
                    color: #4285F4;
                  }
                  &.disabled {
                    cursor: not-allowed;
                    color: rgba(0, 0, 0, 0.25);
                  }
                }
              }
            }
          }
        }

      }

      td {
        display: inline-block;
        padding: 5px;
        width: 25%;
        span {
          padding: 2px 10px;
          border-radius: 4px;
        }
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partial/customer/CustomerListInstallments.vue